import { Home, Users, FileText, Command, Dot, Settings } from "lucide-react";

export const menuItems = [
  {
    title: "Home",
    url: "/",
    icon: Home,
  },
  {
    title: "Farm Management",
    url: "#",
    icon: Command,
    children: [
      {
        title: "Farms",
        url: "/farm-management/farms",
        icon: Dot,
      },
      {
        title: "Greenhouses",
        url: "/farm-management/greenhouses",
        icon: Dot,
      },
      {
        title: "Bays",
        url: "/farm-management/bays",
        icon: Dot,
      },
      {
        title: "Beds",
        url: "/farm-management/beds",
        icon: Dot,
      },
    ],
  },
  {
    title: "Settings",
    url: "#",
    icon: Settings,
    children: [
      {
        title: "Profile",
        url: "#/settings/profile",
        icon: Dot,
      },
      {
        title: "Security",
        url: "#/settings/security",
        icon: Dot,
      },
      {
        title: "Privacy",
        url: "#/settings/privacy",
        icon: Dot,
      },
      {
        title: "Preferences",
        url: "#/settings/preferences",
        icon: Dot,
      },
      {
        title: "Appearance",
        url: "#/settings/appearance",
        icon: Dot,
      },
      {
        title: "Language",
        url: "#/settings/language",
        icon: Dot,
      },
    ],
  },
  {
    title: "Reports",
    url: "#",
    icon: FileText,
    children: [
      {
        title: "Analytics",
        url: "#/reports/analytics",
        icon: Dot,
      },
      {
        title: "Users",
        url: "#/reports/users",
        icon: Dot,
      },
      {
        title: "Database",
        url: "#/reports/database",
        icon: Dot,
      },
    ],
  },
  {
    title: "Team Management",
    url: "#",
    icon: Users,
    children: [
      {
        title: "Users",
        url: "#/reports/analytics",
        icon: Dot,
      },
      {
        title: "Roles",
        url: "#/reports/roles",
        icon: Dot,
      },
    ],
  },
];
